import RwCustodianService from '@advisor/rwSdk/CustodianService';
import RwOrchestrateService from '@advisor/rwSdk/OrchestrateService';
import exceptionHandler from '@advisor/util/exceptionHandler';
import {addRiaComponentTo} from '@advisor/util/store/paramInjects';

// initial state
export const stateObj = function () {
  return {
    beneficiaries: [],
    trustedContacts: [],
    emailResponse: {},
  };
};

// actions
export const actions = {
  // eslint-disable-next-line consistent-return
  async getClientBeneficiaries({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const sdkResponse = await RwCustodianService.getBeneficiaries(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_BENEFICIARIES', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('beneficiaries.getClientBeneficiaries', error);
    }
  },
  // eslint-disable-next-line consistent-return
  async getClientTrustedContacts({commit, rootState}, payload) {
    try {
      const fullPayload = addRiaComponentTo(payload, rootState.settings.default);
      const sdkResponse = await RwCustodianService.getTrustedContact(fullPayload).catch((error) => {
        throw error;
      });

      commit('SET_TRUSTED_CONTACTS', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('beneficiaries.getClientTrustedContacts', error);
    }
  },
  // eslint-disable-next-line consistent-return
  async sendEmailToClient({commit}, payload) {
    try {
      const sdkResponse = await RwOrchestrateService.sendEmailToClient(payload).catch((error) => {
        throw error;
      });

      commit('SET_EMAIL_RESPONSE', sdkResponse);

      return Promise.resolve(sdkResponse);
    } catch (error) {
      exceptionHandler.handleGenericException('beneficiaries.sendEmailToClient', error);
    }
  },
};

// mutations
export const mutations = {
  // eslint-disable-next-line no-shadow
  SET_BENEFICIARIES(state, payload) {
    state.beneficiaries = Array.isArray(payload) ? payload : [payload];
  },
  // eslint-disable-next-line no-shadow
  SET_TRUSTED_CONTACTS(state, payload) {
    state.trustedContacts = Array.isArray(payload) ? payload : [payload];
  },
  SET_EMAIL_RESPONSE(state, payload) {
    state.emailResponse = payload instanceof Object ? payload : {};
  },
};

export default {
  namespaced: true,
  state: stateObj,
  actions,
  mutations,
};
